import { configureStore } from "@reduxjs/toolkit";

import errorSlice from "./slices/errorSlice";
import sidebarSlice from "./slices/sidebarSlice";
import userSlice from "./slices/userSlice";
import chatSlice from "./slices/chatSlice";
import loadingSlice from "./slices/loadingSlice";

export const store = configureStore({
    reducer: {
        error: errorSlice,
        sidebar: sidebarSlice,
        user: userSlice,
        chat: chatSlice,
        loading: loadingSlice,
    }
});